import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import HeroSection from './components/HeroSection';
import LiveMatchesSection from './components/LiveMatchesSection';
import CategoriesSection from './components/CategoriesSection';
import HotMatchesSection from './components/HotMatchesSection';
import StatsSection from './components/StatsSection';
import AdvantagesSection from './components/AdvantagesSection';
import NewsSection from './components/NewsSection';
import FAQSection from './components/FAQSection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <LiveMatchesSection />
        <CategoriesSection />
        <StatsSection />
        <HotMatchesSection />
        <AdvantagesSection />
        <NewsSection />
        <FAQSection />
      </main>
      <Footer />
      <ScrollToTop />

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: `{"@context":"https://schema.org","@type":"WebPage","name":"kaiyun.com 官方平台——开云体育登录入口","description":"kaiyun.com 是领先的综合性体育娱乐平台，提供体育赛事竞猜、实时赔率、在线娱乐等服务。","url":"https://www.kaiyun.com/","isPartOf":{"@type":"WebSite","name":"kaiyun.com","url":"https://www.kaiyun.com/"}}` }} />

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: `{"@context":"https://schema.org","@type":"FAQPage","mainEntity":[{"@type":"Question","name":"如何在 kaiyun.com 注册账号？","acceptedAnswer":{"@type":"Answer","text":"点击网站右上角的立即注册按钮，填写手机号或邮箱，设置密码，完成短信/邮箱验证即可成功注册。整个过程只需1-2分钟。"}},{"@type":"Question","name":"kaiyun.com 支持哪些充值方式？","acceptedAnswer":{"@type":"Answer","text":"我们支持多种充值方式，包括银行卡转账、微信支付、支付宝、USDT等加密货币，以及多种电子钱包。充值实时到账，无手续费。"}},{"@type":"Question","name":"提现需要多长时间到账？","acceptedAnswer":{"@type":"Answer","text":"kaiyun.com 以提现速度快著称，审核通过后小额提现秒到账，大额提现通常在30分钟内到账。我们承诺全网最快的提现速度。"}},{"@type":"Question","name":"kaiyun.com 平台是否安全可靠？","acceptedAnswer":{"@type":"Answer","text":"kaiyun.com 持有国际合法运营牌照，采用银行级SSL加密技术保护用户数据，所有资金由第三方托管，确保平台安全可靠运营。"}},{"@type":"Question","name":"如何联系客服？","acceptedAnswer":{"@type":"Answer","text":"您可以通过在线客服（7x24小时）、官方邮箱 support@kaiyun.com 或官方社交媒体账号联系我们。我们的客服团队随时为您服务。"}}]}` }} />
    </>
  );
}